module.exports = __webpack_public_path__ + "static/media/main_mob@3x.09a2536a.png";